import type { CognitoUser } from "amazon-cognito-identity-js";
import differenceInSeconds from "date-fns/differenceInSeconds";

export const getGetSecondsUntilNextloginAttempt = ({
  challengeParam,
}: CognitoUser): number => {
  const { nextLoginAttemptAt } = challengeParam || {};

  if (!nextLoginAttemptAt) {
    return 0;
  }

  const nextLoginAttemptDate = new Date(nextLoginAttemptAt);

  return differenceInSeconds(nextLoginAttemptDate, new Date());
};
